import { takeLatest, put } from 'redux-saga/effects';
import { GET_USER, GET_USER_LI } from '../constants';
import { getUserData, getUserLiData } from '../actions';
import axios from 'axios';
import dlCommon from '../dlCommon';
import User from '../models/User';


export function* sgGetUser(action) {
    const itemId = action.payload;
    const url = dlCommon.apiUrlGet('user', itemId);
    // console.log(url);
    
    const item = yield axios.get(url).then((res) => {
        let user = new User();
        user.obSet(res.data);
        return user;
    });
    
    yield put(getUserData(item));

}

export function* sgGetUserLi(action) {
    const condS = JSON.stringify(action.payload);
    const url = dlCommon.apiUrlGet('user') + '?mgsFind=' + condS;
    const item = yield axios.get(url).then((res) => {
        let userN = res.data.map((item) => {
            let user = new User();
            user.obSet(item);
            return user;
        });
        return userN;
    });
    yield put(getUserLiData(item));
}

export function* actWatchUser() {
    yield takeLatest(GET_USER, sgGetUser); 
    yield takeLatest(GET_USER_LI, sgGetUserLi);
}

